<template>
  <!-- 原成员管理页面 -->
  <div>
    <div class="m-box">
      <div class="org-tree">
        <div class="arch-model-sty">
          <div v-if="orgSyncType || currentAuthUser.deptSyncType" style="flex: 1">
            <span>
              <span style="font-weight: bolder;">组织架构模式：</span>
              <span>{{ orgSyncType === 1 || currentAuthUser.deptSyncType === 1 ? '钉钉架构' : '自行管理'}}</span>
            </span>
            <el-tooltip class="item" effect="dark" content="切换" placement="top-start">
              <span @click="synchronous" class="chang-box-sty">
                <i style="font-size: 18px" class="el-icon-sort change-icon-sty"></i>
              </span>
            </el-tooltip>
          </div>
          <div v-if="orgSyncType !== 1 || currentAuthUser.deptSyncType !== 1">
            <el-button
              style="width: 80px; margin-right: 10px"
              v-if="!isInDingTalk"
              type="primary"
              size="mini"
              plain
              @click="handleJoinApplyVisi"
            >成员审核
            </el-button>
            <span v-if="applyTotal" class="apply-sty">{{ applyTotal }}</span>
          </div>
          <el-button
            type="primary"
            size="mini"
            plain
            @click="addMember"
          >邀请成员
          </el-button>
        </div>
        <div class="member-tree-box">
          <el-tree
            class="tree-style member-tree"
            :data="topGroup"
            :highlight-current="true"
            :expand-on-click-node="false"
            node-key="corpGroupId"
            :default-expand-all="true"
            ref="memberTree"
            :check-strictly="true"
            :props="defaultProps"
            @node-click="handleNodeClick"
          >
            <div
              slot-scope="{ node, data }"
              class="wrap"
              :title="`${data.groupName}(${data.totalNum}人${deptManager(data)})`"
            >
              <p class="name">{{ `${data.groupName}（${data.totalNum}人${deptManager(data)}）`}}</p>
              <span class="option-sty">
                <el-tooltip class="item" effect="dark" content="添加下级部门" placement="top-start">
                  <img src="/images/addSub.png" alt width="16" v-show="deptEditShow(data)"
                    @click="handleClickAddChild(data)"/>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="调整部门" placement="top-start">
                  <i
                    class="el-icon-edit-outline"
                    v-show="deptEditShow(data) && node.level !== 1"
                    @click="handleClickEditSelf(data)"
                  ></i>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="删除部门" placement="top-start">
                  <i
                    class="el-icon-delete-solid"
                    v-show="deptEditShow(data) && node.level !== 1"
                    @click="handleClickDeleteSelf(data)"
                  ></i>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="设置主管" placement="top-start">
                  <i class="el-icon-s-custom" v-show="deptEditShow(data)" @click="setManagement(data)"></i>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="上移" placement="top-start">
                  <i
                    class="el-icon-top"
                    v-show="deptEditShow(data) && node.level !== 1"
                    @click="upSortFn(data)"
                  ></i>
                </el-tooltip>
              </span>
            </div>
          </el-tree>
        </div>
      </div>
      <div class="right-box">
        <div class="flex-sty com-ht">
          <h1 class="com-title" style="font-weight: bold">
            <div>
              <i></i>{{ selectTreeNode.groupName }}
            </div>
          </h1>
          <!-- member table search -->
          <el-row type="flex" :gutter="5">
            <el-col :span="24" style="text-align: right">
              <el-form :inline="true" :model="filterModel" size="mini" class="demo-form-inline">
                <el-form-item label>
                  <el-input
                    style="width: 140px"
                    clearable
                    v-model="filterModel.targetId"
                    placeholder="姓名/邮箱/手机号"
                  ></el-input>
                </el-form-item>
                <el-form-item label>
                  <el-select
                    style="width: 100px"
                    v-model="filterModel.inviteStatus"
                    placeholder="请选择状态"
                  >
                    <el-option label="全部状态" value></el-option>
                    <el-option label="已移除" :value="-1"></el-option>
                    <el-option label="正常" :value="1"></el-option>
                    <el-option label="待接受" :value="0"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label>
                  <el-select
                    style="width: 120px"
                    v-model="filterModel.corpRoleId"
                    placeholder="请选择权限组"
                  >
                    <el-option
                      v-for="(v, index) in roles"
                      :key="index"
                      :label="v.label"
                      :value="v.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button @click="filterSearch(1)">查询</el-button>
                </el-form-item>
                <el-form-item style="margin-right: 0">
                  <el-button @click="rest">重置</el-button>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
        </div>
        <div style="padding: 15px 20px">
          <!-- table -->
          <el-row :gutter="20">
            <el-col :span="24">
              <!-- @selection-change="handleSelectionChange" -->
              <el-table
                :data="tableList"
                style="border: 1px solid #eeeeee; border-bottom: 0"
                tooltip-effect="dark"
                :header-cell-style="{
                background: '#f9f9f9',
                color: '#333333',
                fontWeight: '600',
              }"
              >
                <!-- <el-table-column type="selection" width="55" /> -->
                <el-table-column label="成员信息" show-overflow-tooltip min-width="220">
                  <template slot-scope="scope">
                    <!-- scope.row.userName + scope.row.groupMan === 1 ? '(主管)' : '' -->
                    <div
                      class="tr-overflow"
                      :title="
                      scope.row.userName +
                      (scope.row.groupMan === 1 ? '(主管)' : '')
                    "
                    >
                    <span
                      :class="
                        scope.row.groupMan !== 1
                          ? 'ellipses-1-full'
                          : 'ellipses-1'
                      "
                    >
                      <template
                        v-if="
                          scope.row.useStatus === -1 &&
                          scope.row.inviteStatus === -1
                        "
                      >
                        <!--                          已移除显示删除线-->
                        <span class="delline">
                          {{ scope.row.userName }}
                          <span></span>
                        </span>
                      </template>
                      <template v-else>{{ scope.row.userName }}</template>
                    </span>
<!--                      <span-->
<!--                        class="ellipses-2"-->
<!--                        style="color: #ec1c1c"-->
<!--                        v-if="scope.row.groupMan === 1 && orgSyncType !== 1"-->
<!--                      >（主管）</span>-->

                      <div style="clear: both"></div>
                    </div>
                    <p class="tr-overflow">账号：{{ scope.row.targetId }}</p>
                    <p class="tr-overflow">部门：{{ scope.row.groupNames }}</p>
                  </template>
                </el-table-column>
                <el-table-column label="状态" prop="useStatus" width="100">
                  <template slot-scope="scope">
                    <p
                      v-if="
                      scope.row.useStatus === -1 &&
                      scope.row.inviteStatus === -1
                    "
                    >
                      <span class="dot-orange">●</span> 已移除
                    </p>
                    <p v-if="scope.row.useStatus === 0">
                      <span class="dot-green">●</span> 正常
                    </p>
                    <p
                      v-if="
                      scope.row.useStatus === -1 &&
                      scope.row.inviteStatus === 0
                    "
                    >
                      <span class="dot-red">●</span> 待接受
                    </p>
                  </template>
                </el-table-column>
                <el-table-column label="权限组及可管理部门" min-width="300" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <p v-for="(v, i) of scope.row._roleNames" :key="i">{{ v }}</p>
                    <span v-if="!scope.row._roleNames.length">默认查看权限</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="130">
                  <template slot-scope="scope">
                    <p
                      class="color-success"
                      :class="{
                      'dis-sty': haveFlag(scope.row),
                    }"
                      v-if="
                      scope.row.useStatus === -1 &&
                      scope.row.inviteStatus === 0
                    "
                      @click="handleDel(scope.row)"
                    >删除邀请</p>
                    <!-- 分配角色 -->
                    <p
                      class="color-success"
                      :class="{
                      'dis-sty': haveFlag(scope.row),
                    }"
                      v-if="
                      !(
                        scope.row.useStatus === -1 &&
                        scope.row.inviteStatus === -1
                      )
                    "
                      @click="handleClickAssign(scope.row)"
                    >分配权限</p>
                    <!-- -1 未绑定 1 正常 2 待接受 -->
                    <p
                      class="color-success pointer"
                      :class="{ 'dis-sty': haveFlag(scope.row) }"
                      @click="handleClickBind(scope.row)"
                      v-if="
                      scope.row.useStatus === -1 &&
                      scope.row.inviteStatus === -1
                    "
                    >继承数据</p>
                    <p
                      class="color-success pointer"
                      :class="{ 'dis-sty': haveFlag(scope.row) }"
                      @click="contractVisibleFn(scope.row)"
                      v-if="
                      scope.row.useStatus === -1 &&
                      scope.row.inviteStatus === -1
                    "
                    >合同交接</p>
                    <p
                      class="color-success pointer"
                      :class="{ 'dis-sty': haveFlag(scope.row) }"
                      @click="handleClickReinvite(scope.row)"
                      v-else-if="
                      scope.row.useStatus === -1 &&
                      scope.row.inviteStatus === 0
                    "
                    >重新邀请</p>
                    <p
                      class="color-success pointer"
                      :class="{ 'dis-sty': haveFlag(scope.row) }"
                      @click="handleClickUnbind(scope.row)"
                      v-else-if="scope.row.useStatus === 0"
                    >移出组织</p>

                    <p
                      v-if="someFn(scope.row) && scope.row.useStatus === 0"
                      class="color-success pointer"
                      :class="{ 'dis-sty': haveFlag(scope.row) }"
                      @click="moveOrg(scope.row)"
                    >更换部门</p>
                  </template>
                </el-table-column>
                <no-data text="暂无数据" slot="empty"/>
              </el-table>
            </el-col>
          </el-row>
          <!--分页栏-->
          <el-row class="pageation">
            <el-col :span="24" style="padding: 30px 0" class="page-flex-end">
              <el-pagination
                small
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="filterModel.itemPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="filterModel.pageSize"
                layout="sizes, prev, pager, next, total"
                :total="filterModel.pageTotal"
              />
              <el-go
                :page-size="filterModel.pageSize"
                :total="filterModel.pageTotal"
                @current-change="handleCurrentChange"
              ></el-go>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <el-dialog title="继承数据" :visible.sync="visibleBindMember" width="30%">
      <i class="warn-img el-icon-warning" style="vertical-align: top; margin-top: 3px"></i>
      <p
        style="
          font-size: 14px;
          font-weight: 400;
          line-height: 24px;
          color: #290202;
          margin-bottom: 20px;
          width: 95%;
          display: inline-block;
        "
      >邀请新成员，并将当前已移出的成员的全部签署文件、权限组以及印章和模板继承给新加入的成员。</p>

      <el-form
        ref="dialogModelBindMember"
        :rules="formAddMemberRules"
        label-position="right"
        label-width="80px"
        :model="dialogModelBindMember"
      >
        <el-form-item label="成员类型">
          <el-select
            size="mini"
            v-model="dialogModelBindMember.type"
            @change="handleChangeMemberType1"
            placeholder="请选择"
          >
            <el-option label="个人" :value="0"></el-option>
            <!-- <el-option label="企业" :value="1"></el-option> -->
          </el-select>
        </el-form-item>
        <el-form-item label="手机号" v-if="dialogModelBindMember.type === 0" prop="phone">
          <el-input
            size="mini"
            v-model="dialogModelBindMember.phone"
            :maxlength="11"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="邮箱" v-if="dialogModelBindMember.type === 1" prop="email">
          <el-input
            size="mini"
            v-model="dialogModelBindMember.email"
            :maxlength="32"
            placeholder="请输入邮箱"
          ></el-input>
        </el-form-item>
        <el-form-item label="姓名" v-if="dialogModelBindMember.type === 0" prop="name">
          <el-input
            size="mini"
            v-model="dialogModelBindMember.name"
            :maxlength="32"
            placeholder="请输入姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="企业名称" v-if="dialogModelBindMember.type === 1" prop="enterpriseName">
          <el-input
            size="mini"
            v-model="dialogModelBindMember.enterpriseName"
            :maxlength="32"
            placeholder="请输入企业名称"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="visibleBindMember = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="bindMemberSubmit()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- rebind member dialog -->
    <!-- 重新邀请 Dialog -->
    <el-dialog title="重新邀请" :visible.sync="visibleReBindMember" width="30%">
      <el-form
        ref="dialogModelReBindMember"
        :rules="formAddMemberRules"
        label-position="right"
        label-width="80px"
        :model="dialogModelReBindMember"
      >
        <el-form-item label="成员类型">
          <el-select
            size="mini"
            v-model="dialogModelReBindMember.type"
            @change="handleChangeMemberType2"
            placeholder="请选择"
          >
            <el-option label="个人" :value="0"></el-option>
            <!-- <el-option label="企业" :value="1"></el-option> -->
          </el-select>
        </el-form-item>
        <el-form-item label="手机号" v-if="dialogModelReBindMember.type === 0" prop="phone">
          <el-input
            size="mini"
            v-model="dialogModelReBindMember.phone"
            :maxlength="11"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="邮箱" v-if="dialogModelReBindMember.type === 1" prop="email">
          <el-input
            size="mini"
            v-model="dialogModelReBindMember.email"
            :maxlength="32"
            placeholder="请输入邮箱"
          ></el-input>
        </el-form-item>
        <el-form-item label="姓名" v-if="dialogModelReBindMember.type === 0" prop="name">
          <el-input
            size="mini"
            v-model="dialogModelReBindMember.name"
            :maxlength="32"
            placeholder="请输入姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="企业名称" v-if="dialogModelReBindMember.type === 1" prop="enterpriseName">
          <el-input
            size="mini"
            v-model="dialogModelReBindMember.enterpriseName"
            :maxlength="32"
            placeholder="请输入企业名称"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="visibleReBindMember = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="rebindMemberSubmit()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- add member dialog -->
    <!-- 添加成员 Dialog -->
    <add-member :show.sync="visibleAddMember" :callback="queryTool" @refresh="initTreeGroup"/>
    <!-- remove member org dialog -->
    <!-- 调整组织 Dialog -->
    <el-dialog title="选择调整组织" :visible.sync="visibleMoveOrg" width="30%">
      <el-tree
        ref="referenceMoveTree"
        class="tree-style"
        :data="treeGroupCopy"
        :highlight-current="true"
        :default-expand-all="true"
        :expand-on-click-node="false"
        :filter-node-method="(value, data) => data.editFlag !== 0"
        node-key="corpGroupId"
        :props="defaultProps"
        @node-click="handleNodeClickMove"
      ></el-tree>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="visibleMoveOrg = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="moveOrgSubmit()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- assign role -->
    <!-- 角色分配 -->
    <el-dialog
      class="custom-table com-dialog"
      width="50%"
      top="10vh"
      title="分配权限"
      :visible.sync="showDistribute"
      @close="clearSelection('roleSelection')"
    >
      <el-row>
        <p class="my-title" v-if="creatRoleVisibleBtn">
          <span>
            <img src="/images/web/icon-shou.png"/>选择下列权限组赋给成员，则可以使用系统相应的功能，也可以新建一个权限组赋给成员
          </span>
          <el-button size="mini" type="primary" @click="createdRoleGroup">创建权限组</el-button>
        </p>
        <el-table
          max-height="400px"
          ref="roleSelection"
          :data="distributeRoles"
          @select="selectedChange"
          @selection-change="distributeRoleSelect"
          :default-sort="{ prop: 'corpRoleId', order: 'ascending' }"
          border
        >
          <el-table-column type="selection" max-width="55"></el-table-column>
          <el-table-column property="groupName" label="需要管理的部门">
            <template slot-scope="scope">
              <p>
                {{ scope.row.groupName || distibuteInfo.groupNames }}
                <span
                  class="color-success"
                  style="margin-right: 10px; cursor: pointer"
                  type="text"
                  size="mini"
                  @click="chooseAuth(scope.row, scope.$index)"
                >修改</span>
              </p>
            </template>
          </el-table-column>
          <el-table-column property="roleName" label="权限组名称" max-width="200"></el-table-column>
          <el-table-column property="remark" label="权限组描述" max-width="200"></el-table-column>
          <el-table-column label="权限组操作" width="120">
            <template slot-scope="scope">
              <!--               v-if="creatRoleVisibleBtn"-->
              <template>
                <span
                  class="color-success"
                  style="cursor: pointer; margin-right: 10px"
                  type="text"
                  size="mini"
                  @click="editRole(scope.row)"
                >查看</span>
              </template>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <el-row slot="footer" class="dialog-footer">
        <el-button size="mini" @click="showDistribute = false">取消</el-button>
        <el-button size="mini" type="primary" @click="doDistribute">确定</el-button>
      </el-row>
      <el-dialog title="选择权限范围" :visible.sync="showChooseAuth" append-to-body>
        <el-tree
          :data="treeGroup"
          ref="treeRef"
          node-key="corpGroupId"
          :default-expanded-keys="treeGroupKeys"
          :highlight-current="true"
          :props="defaultProps"
          @node-click="checkGroup"
        ></el-tree>
        <el-row slot="footer" class="dialog-footer">
          <el-button size="mini" @click="showChooseAuth = false">取消</el-button>
          <el-button size="mini" type="primary" @click="doChooseAuth">确定</el-button>
        </el-row>
      </el-dialog>
    </el-dialog>
    <role-form
      v-if="dialogVisi"
      :diaTitle="diaTitle"
      :rowInfo="rowInfo"
      :viewDetail="true"
      :distributeRoles="distributeRoles"
      @closePup="closePup"
      @getRoles="susChange"
    ></role-form>
    <!-- 加入申请列表 -->
    <join-apply :joinApplyVisi.sync="joinApplyVisi" @refresh="getApplyList"></join-apply>
    <!-- 合同数据交接   -->
    <el-dialog title="合同数据交接" :visible.sync="contractSendVisible">
      <template>
        <p style="border-bottom: 1px solid #f0f0f0">将当前已移出的成员的合同数据抄送给所选择的成员。</p>
        <div style="text-align: right">
          <el-input style="width: 300px; margin-right: 10px" size="small" placeholder="请输入姓名"
                    v-model="filterModelNew.targetId"></el-input>
          <el-button type="primary" size="small" @click="contractSendUserListFn">搜索</el-button>
        </div>
        <ul>
          <li
            :class="[
              'contract_li',
              { active: item.corpUserId === contractSendActive },
            ]"
            v-for="(item, index) in contractSendUserList"
            @click="contractSendActive = item.corpUserId"
            :key="index"
          >{{ item.userName }}（账号：{{ item.targetId }}）
          </li>
        </ul>
        <div style="position: relative; padding: 30px 0 0 0" class="page-flex-end">
          <el-pagination
            @size-change="handleSizeChangeNew"
            @current-change="handleCurrentChangeNew"
            :current-page="filterModelNew.itemPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="filterModelNew.pageSize"
            layout="sizes, prev, pager, next, total"
            :total="filterModelNew.pageTotal"
          />
          <el-go
            :page-size="filterModelNew.pageSize"
            :total="filterModelNew.pageTotal"
            @current-change="handleCurrentChangeNew"
          ></el-go>
        </div>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button @click="contractSendVisible = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="contractSendFn" size="mini">确 定</el-button>
      </span>
    </el-dialog>
    <!-- components -->
    <!-- 添加/编辑部门 -->
    <add-child-pup
      :visibleDialogTitle="visibleDialogTitle"
      :visibleDialog.sync="visibleDialog"
      :superDeptsTree="superDeptsTree"
      :pupModel="modelDialog"
      :isEdit="isEdit"
      @refresh="refresh"
    ></add-child-pup>
    <!-- 设置主管 -->
    <supervisor
      :visibleDialogSetManager.sync="visibleDialogSetManager"
      :selectCorpGroupId="selectTreeNode.corpGroupId"
      @refresh="refresh"
    ></supervisor>
    <!-- 同步组织架构 -->
    <sync-organ-pup
      center
      title="组织架构同步配置"
      :orgSyncType="orgSyncType"
      :visible.sync="orgSyncVisi"
      width="40%"
      @close="closeSyncDialog"
    ></sync-organ-pup>
  </div>
</template>

<script>
  // components
  import syncOrganPup from "./components/syncOrganPup.vue";
  import supervisor from "./components/supervisor.vue";
  import addChildPup from "./components/addChildPup.vue";
  import ElGo from "@/components/go/Go.vue";
  import joinApply from "./components/joinApply.vue";
  // import roleForm from "@/components/console/roleForm";
  import roleForm from "./components/rloeFormNew.vue";
  import addMember from "@/components/console/addMember";
  import showRes from "@/assets/js/http-serve/corp/showApiRes";
  // API
  import {dingtalkApi} from "../../../assets/js/http-serve/dingtalkApi";
  import {ApiMethods} from "../../../assets/js/http-serve/http-methods";
  import {ApiCorpMethods} from "@/assets/js/http-serve/corp/http-methods";
  // data
  import {gantConf, getPermInfo} from "../../../assets/js/utils/jurisdiction";
  import {callbackLog} from "@/assets/js/utils/publicMethods";
  import {
    isInDingTalk
  } from "../../../assets/js/utils/ding-env";
  import * as dd from "dingtalk-jsapi/entry/union";
  // tool
  import {mapGetters} from "vuex";
  import {
    name,
    enterpriseName,
    mobile,
    email
  } from "@/assets/js/lib/valid-methods";
  import Bus from "@/plugins/bus.js";

  export default {
    name: "member",
    components: {ElGo, roleForm, addMember, joinApply, addChildPup, supervisor, syncOrganPup},
    data() {
      // 判断是否有分配角色按钮
      let assignRoleVisibleBtn = false;
      let creatRoleVisibleBtn = false;
      let showSet = false;
      // console.log(this.$store.getters.currentAuthUser, 66666)
      if (this.$store.getters.currentAuthUser.perms) {
        let permsArr = this.$store.getters.currentAuthUser.perms;
        let permsStr = permsArr.join();
        if (
          permsStr.indexOf("9") > -1 ||
          permsArr.indexOf(gantConf.organStru) > -1
        ) {
          assignRoleVisibleBtn = true;
        }
        if (
          permsStr.indexOf("8") > -1 ||
          permsArr.indexOf(gantConf.roleManage) > -1
        ) {
          creatRoleVisibleBtn = true;
        }
        if (
          permsStr.indexOf("7") > -1 ||
          permsArr.indexOf(gantConf.organStru) > -1
        ) {
          showSet = true;
        }
      }
      return {
        orgSyncVisi: false, // 同步组织架构配置弹窗显示控制
        /** 1：自动同步钉钉组织架构；2：自行管理组织架构 ,无值或者无字段：从未设置过 */
        orgSyncType: null,
        DINGSDK: null,
        topGroupId: '', //节点上一级id
        dataAuthText: '暂无该部门的权限，如需使用，请联系管理员修改权限范围',
        // 同步组织架构 start
        // 钉钉同步组织loading
        syncLoading: false,
        dingTreeData: [],
        // 设置主管
        visibleDialogSetManager: false,
        // 添加下级组件
        isEdit: true,
        modelDialog: {},
        orgMap: {},
        visibleDialogTitle: "添加部门",
        superDepts: {},
        superDeptsTree: [],
        superDeptsTreeCopy: [],
        visibleDialog: false, // 添加/修改下级弹窗控制
        applyTotal: 0, //审核总数
        isInDingTalk,
        selectUserObj: {},
        contractSendVisible: false, //合同数据交接
        contractSendUserList: [], //数据
        contractSendActive: "",
        joinApplyVisi: false,
        dialogVisi: false,
        diaTitle: "创建权限组",
        rowInfo: {},
        selectRows: [], // 某人的角色选中
        // ! 以上 2022/9/06
        selectTreeNode: {}, // 选中的树节点
        // 成员管理 要求成员 按钮onlyClickOnce限制
        // 角色分配显示隐藏按钮
        assignRoleVisibleBtn: assignRoleVisibleBtn,
        // 角色创建修改显示隐藏按钮
        creatRoleVisibleBtn: creatRoleVisibleBtn,
        showSet: showSet, // 控制组织架构显示隐藏
        showDistribute: false, //控制分配角色窗口显隐
        showChooseAuth: false, //控制选择权限范围窗口
        //角色分配
        memberList: [], //成员列表
        distibuteInfo: {}, //分配成员的信息
        distributeSeals: [], //分配成员 可用签章
        distributeRoles: [], //分配成员 可用角色
        distributeRoleJson: [],
        distributeSealJson: [],
        treeGroupKeys: [],
        // 角色数据
        roles: [],
        moveDeptSelect: undefined, // 转移部门 选中值
        treeGroup: [],
        // 带有权限的tree
        topGroup: [],
        treeGroupCopy: [],
        departmentArray: [],
        selectMember: [],
        defaultProps: {
          children: "childCorpGroups",
          label: "groupName",
        },
        // filter model
        filterModel: {
          targetId: "", // 手机/邮箱 ... 关键字
          useStatus: "", // -1未激活 0正常 1停用
          inviteStatus: "", // 邀请状态 -1 未绑定 0 已邀请 1已邀请
          corpRoleId: "", // 角色id
          corpGroupId: "", // 部门id
          useType: "", // 用户类型 0个人1企业
          itemPage: 1,
          pageSize: 10,
          pageTotal: 0
        },
        filterModelNew: {
          targetId: "", // 手机/邮箱 ... 关键字
          useStatus: "", // -1未激活 0正常 1停用
          inviteStatus: "1", // 邀请状态 -1 未绑定 0 已邀请 1已邀请
          corpRoleId: "", // 角色id
          corpGroupId: "", // 部门id
          useType: "", // 用户类型 0个人1企业
          itemPage: 1,
          pageSize: 10,
          pageTotal: 0
        },
        tableList: [],
        // dialog visible
        visibleBindMember: false,
        visibleReBindMember: false,
        visibleAddMember: false,
        visibleMoveOrg: false,
        // dialogModel
        dialogModelBindMember: {
          corpUserId: "",
          type: 0,
          phone: "",
          email: "",
          name: "",
          enterpriseName: ""
        },
        dialogModelReBindMember: {
          corpUserId: "",
          type: 0,
          phone: "",
          email: "",
          name: "",
          enterpriseName: ""
        },

      formAddMemberRules: {
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: mobile, trigger: "change" }
        ],
        email: [
          { required: true, message: "请输入邮箱号", trigger: "blur" },
          { validator: email, trigger: "change" }
        ],
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { validator: name, trigger: "change" }
        ],
        enterpriseName: [
          { required: true, message: "请输入企业名称", trigger: "blur" },
          { validator: enterpriseName, trigger: "change" }
        ],
        department: [
          { required: true, message: "请选择部门", trigger: "change" }
        ]
      },
      // 角色权限相关
      showRole: false,
      roleModel: {
        roleName: "",
        remark: "",
        perms: []
      }
    };
  },
  async created () {
    // 获取角色下拉数据
    this.getRoles();
    if (isInDingTalk) {
      this.getDingDeptTree();
      this.dingOrgSyncStatus();
      this.DINGSDK = await this.$DingSDKPromise();
    }
  },
  mounted () {
    this.mountHands();
  },
  methods: {
    /** 区分显示钉钉和saas环境的主管 */
    deptManager(row){
      const {
        corpGroupManName:SaaSMUser,
        thirdGroupManId:dingMId,
        thirdGroupManName:dingMUser
      } = row,curr = this.selectTreeNode.corpGroupId === row.corpGroupId;
      const saasSyncType = this.currentAuthUser.deptSyncType !== 1;
      if(isInDingTalk){
        // return (dingMId && dingMUser) && this.orgSyncType !== 1 ? `-${dingMUser}` : ''
        return (dingMId && dingMUser) ? `-${dingMUser}` : ''
      }else{
        return SaaSMUser && saasSyncType ? `- ${ SaaSMUser}` : ''
      }
    },
    /** 部门树状列表编辑显示控制 */
    deptEditShow (row) {
      const curr = this.selectTreeNode.corpGroupId === row.corpGroupId;
      const saasSyncType = this.currentAuthUser.deptSyncType !== 1;
      return isInDingTalk ? curr && this.orgSyncType !== 1 : curr && saasSyncType;
    },
    /** 关闭同步弹窗 */
    closeSyncDialog () {
      this.orgSyncVisi = false;
      if(isInDingTalk){
        // 更新数据
        this.mountHands();
        this.getDingDeptTree();
        this.dingOrgSyncStatus();
      }
    },
    /** 钉钉同步状态查询 */
    dingOrgSyncStatus () {
      const {dingTalkCorpId: corpId, dingTalkUserId} = JSON.parse(sessionStorage.getItem("dingloginInfo")),
        _this = this;
      dingtalkApi.orgSync({ corpId, dingTalkUserId }).then(res => {
        if (!res.success) return _this.$message.error(res.description)
        // data 1：自动同步钉钉组织架构；2：自行管理组织架构 ,无值或者无字段：从未设置过
        this.orgSyncType = res.data;
      })
    },
    /** 创建权限组入口 */
    createdRoleGroup(){
      const have = this.perms.includes(gantConf.roleManage)
      if (!have) {
        const Pinfo = getPermInfo(gantConf.roleManage)
        return this.$message.error(`暂无【${Pinfo.name}】权限，如需使用请联系管理员开通`)
      }
      Bus.$emit("listenClickTab", "role");
      Bus.$emit("otherAddWay")
    },
    /** 将mounted钩子要执行的函数放在这里 */
    mountHands(){
      this.initTreeGroup();
      this.getApplyList();
      // 初始更改状态参数
      let query = this.$route.query;
      this.$nextTick(() => {
        if (query && query.status !== "" && query.status !== undefined) {
          // this.filterModel.inviteStatus = query.status
          this.$set(this.filterModel, "inviteStatus", +query.status || 0);
        }
        this.initTableData();
        this.contractSendUserListFn();
      });
    },
    /** 同步saas部门数据 */
    syncConfirm () {
      const _this = this;
      _this.syncLoading = true
      const info = JSON.parse(sessionStorage.getItem("dingloginInfo"));
      const param = { corpId: info.dingTalkCorpId, dingTalkUserId: info.dingTalkUserId }
      dingtalkApi.saasSync(param).then(res => {
        if (!res.success) _this.$message.error(res.description)
        callbackLog({
          module:0,
          desc:`同步钉钉组织架构`
          })
        _this.$message.success(res.description)
      }).finally(() => { _this.syncLoading = false })
    },
    /** 同步SaaS部门数据 */
    saasSyncHandle () {
      const _this = this;
      _this.$confirm(`
      <p>是否确认同步组织架构？</p>
				<p style="color:#ec1c1c">同步后钉钉组织架构将覆盖当前组织架构</p>
			`, '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        dangerouslyUseHTMLString: true
      }).then(() => {
        _this.syncConfirm()
      }).catch(() => { })
    },
    /** 窗口调用刷新 */
    refresh () {
      this.filterSearch(1)
      this.initTreeGroup()
    },
    /** 权限验证 */
    permsEven (pid = gantConf.organStru) {
      const perms = this.perms;
      const bool = perms.includes(pid);
      if (!bool) {
        const Pinfo = getPermInfo(pid)
        this.$message.error(`暂无【${Pinfo.name}】权限，如需使用请联系管理员开通`)
      }
      return bool
    },
    /** 成员审核 */
    handleJoinApplyVisi () {
      const bool = this.permsEven()
      if (!bool) return
      this.joinApplyVisi = true
    },
    /** 同步组织架构 */
    synchronous () {
      this.orgSyncVisi = true;
      // this.saasSyncHandle()
      // 老刘说把弹窗里的确认同步功能放出来
    },
    /** 钉钉环境获取钉钉部门数据 */
    getDingDeptTree () {
      const info = JSON.parse(sessionStorage.getItem("dingloginInfo")), _this = this;
      const param = { corpId: info.dingTalkCorpId, dingTalkUserId: info.dingTalkUserId }
      dingtalkApi.deptList(param).then(res => {
        if (!res.success) return _this.$message.error(res.description)
        _this.dingTreeData = res.data.subDeptList
      })
    },
    /** 添加下级 */
    handleClickAddChild (self) {
      if (self.editFlag !== 1) return this.$message.warning(this.dataAuthText)
      const bool = this.permsEven()
      if (!bool) return
      this.visibleDialog = true
      this.isEdit = false;
      this.modelDialog = {
        parentId: self.corpGroupId,
        parentDeptName: self.groupName,
        departmentName: "",
        departmentId: ""
      }
      this.openDialog(false);
    },
    topGroupIdFind(arr, id){
      try {
        arr.forEach((item, index)=> {
          if (item.corpGroupId === id) {
            if (index) {
              this.topGroupId = arr[index - 1].corpGroupId;
              throw new Error();
            } else {
              throw new Error();
            }
          } else if (item.childCorpGroups) {
            this.topGroupIdFind(item.childCorpGroups, id);
          }
        })
      } catch (e) {

      }
    },
    //上移
    upSortFn(self) {
      this.topGroupId = '';
      this.topGroupIdFind(this.topGroup, self.corpGroupId)
      if (this.topGroupId === '') {
        this.$message.info('已在当前组织层级的第一位！')
        return false;
      }
      ApiCorpMethods.OrganizationController.groupExchange({
        corpGroupId1: self.corpGroupId,
        corpGroupId2: this.topGroupId,
      }).then(res => {
        this.initTreeGroup();
      })
    },
    /** 区分设置主管调用 */
    setManagement(dept){
      isInDingTalk ? this.setUpMangerWithDingTalk(dept) : this.setManagerVisi(dept);
    },
    /** saas设置主管 */
    setManagerVisi (self) {
      if (self.editFlag !== 1) return this.$message.warning(this.dataAuthText)
      const bool = this.permsEven()
      if (!bool) return
      this.visibleDialogSetManager = true
    },
    /** 钉钉设置主管 */
    setUpMangerWithDingTalk(dept){
      const corpId = sessionStorage.getItem("corpId");
      dd.complexChoose({
        maxUsers: 1,
        corpId,
        multiple: false,
        pickedUsers: [],
        disabledUsers: [],
        responseUserOnly: true,
        success: res => {
          if(res.selectedCount > 0){
            const
              user = res.users[0],
              _cloading = this.$loading({
                lock: true,
                text:"正在拼命加载中",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, .5)"
              });
            // 选择成功后重新发起
            ApiCorpMethods.OrganizationController.SetUpDepartment({
              corpGroupId:dept.corpGroupId,
              thirdGroupManId:user.emplId,
              thirdGroupManName:user.name
            }).then(res=>{
              if(!res.success) {return this.$message.error(res.description)}
              this.refresh()
            }).finally(()=>{_cloading.close()})
          }
        },
      }).catch((err) => { console.log("catch_err:", err) });
    },
    handleClickDeleteSelfMessageBoxSuccess () {
      this.$confirm(
        `
					<h5>删除成功</h5>
					<p style="color:#666666"></p>
				`,
        "",
        {
          confirmButtonText: "确定",
          showClose: false,
          dangerouslyUseHTMLString: true,
          type: "success",
          showCancelButton: false
        }
      );
    },
    handleClickDeleteSelfMessageBoxError () {
      this.$confirm(
        `
					<h5>删除失败</h5>
					<p style="color:#666666">该部门或下级部门下有成员，不能删除</p>
				`,
        "",
        {
          confirmButtonText: "确定",
          showClose: false,
          dangerouslyUseHTMLString: true,
          type: "error",
          showCancelButton: false
        }
      );
    },
    /** 删除部门 */
    handleClickDeleteSelf (self) {
      if (self.editFlag !== 1) return this.$message.warning(this.dataAuthText)
      const bool = this.permsEven()
      if (!bool) return
      this.$confirm(
        `
					<h5>是否删除该部门及下级部门</h5>
					<p style="color:#F56C6C">
						当部门或下级部门有成员时将不能删除,
						<span style="color:#666666">您还要继续吗?</span>
					</p>
				`,
        "",
        {
          confirmButtonText: "继续",
          cancelButtonText: "取消",
          showClose: false,
          dangerouslyUseHTMLString: true,
          type: "warning"
        }
      )
        .then(() => {
          let params = {};
          params.corpGroupId = self.corpGroupId;
          ApiCorpMethods.OrganizationController.delGroup(params)
            .then(res => {
              if (res.code === "0") {
                setTimeout(() => {
                  this.handleClickDeleteSelfMessageBoxSuccess();
                  this.initTreeGroup();
                  this.filterSearch(1)
                }, 300);
              } else if (res.code === '10802') {
                this.$message.error(`暂无该部门的权限，如需使用，请联系管理员修改权限范围`);
              } else {
                setTimeout(() => {
                  this.handleClickDeleteSelfMessageBoxError();
                }, 300);
              }
            })
            .catch(error => {
              this.$message.error(error.description);
            });
        })
        .catch(() => { });
    },
    /** 编辑部门 */
    handleClickEditSelf (self) {
      if (self.editFlag !== 1) return this.$message.warning(this.dataAuthText)
      const bool = this.permsEven()
      if (!bool) return
      this.getSuperDepartment(self);
      this.isEdit = true;
      // init parent dept
      this.modelDialog = {
        parentId: self.parentId,
        parentDeptName: self.groupName,
        departmentName: self.groupName,
        departmentId: self.corpGroupId,
      }
      this.openDialog(true);
      // this.$nextTick(() => {
      //   if (this.$refs.tree) {
      //     this.selectNodeDeptId = self.parentId;
      //     this.$refs.tree.setChecked(self, true);
      //   }
      // });
    },
    // 编辑获取上级部门(上级部门的兄弟以及顶级部门)
    getSuperDepartment (self) {
      for (let index = 0; index < this.topGroup.length; index++) {
        this.superDepts = {};
        this.superDepts = JSON.parse(JSON.stringify(this.topGroup[index]));

        if (this.superDepts.childCorpGroups) {
          for (
            let index = 0;
            index < this.superDepts.childCorpGroups.length;
            index++
          ) {
            const element = this.superDepts.childCorpGroups[index];
            if (self.corpGroupId === element.corpGroupId) {
              element.disabled = true;
              // element.d;
              if (element.childCorpGroups) {
                this.recursionSetChildDisabled(element.childCorpGroups);
              }
              break;
            }
            if (element.childCorpGroups) {
              this.recursionGetSuperDepts(self, element.childCorpGroups);
            }
          }
        }
      }
      this.superDeptsTree = [JSON.parse(JSON.stringify(this.superDepts))];
      this.superDeptsTreeCopy = [JSON.parse(JSON.stringify(this.superDepts))];
      console.log('superDeptsTree', this.superDeptsTree);
    },
    recursionSetChildDisabled (childCorpGroups) {
      for (let index = 0; index < childCorpGroups.length; index++) {
        const element = childCorpGroups[index];
        element.disabled = true;
        if (element.childCorpGroups) {
          this.recursionSetChildDisabled(element.childCorpGroups);
        }
      }
    },
    recursionGetSuperDepts (self, childCorpGroups) {
      for (let index = 0; index < childCorpGroups.length; index++) {
        const element = childCorpGroups[index];
        if (self.corpGroupId === element.corpGroupId) {
          element.disabled = true;
          if (element.childCorpGroups) {
            this.recursionSetChildDisabled(element.childCorpGroups);
          }
          break;
        }
        if (element.childCorpGroups) {
          this.recursionGetSuperDepts(self, element.childCorpGroups);
        }
      }
    },
    /** 新增/编辑窗口名称 */
    openDialog (isEdit) {
      if (isEdit) {
        this.visibleDialogTitle = "调整部门";
      } else {
        this.visibleDialogTitle = "添加部门";
      }
      this.visibleDialog = true;
    },
    getApplyList () {
      this.loading = true;
      let FD = new FormData();
      FD.append("pageSize", "1000");
      FD.append("itemPage", "1");
      ApiMethods.accountJoin
        .auditUserList(FD)
        .then(res => {
          this.applyTotal = res.total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    someFn (row) {
      return (
        (!(row.useStatus === -1 && row.inviteStatus === -1)) ||
        (row.useStatus === -1 && row.inviteStatus === -1 && this.selectTreeNode.editFlag === 1)
      );
    },
    groupEditshowFn (obj) {
      return this.distributeRoleJson.some(item => {
        return item.corpRoleId === obj.corpRoleId && item.operType;
      });
    },
    createRole () {
      this.diaTitle = "创建权限组";
      this.dialogVisi = !this.dialogVisi;
    },
    // 子组件关闭窗口
    closePup () {
      this.rowInfo = {};
      this.dialogVisi = false;
    },
    // ! 以上2022/9/06
    /**
     * 获取 角色分配-角色
     * @param row
     * @param type 默认false , true 说明是通过组件更改了角色。去拿 selectRows 的数据，对之前选中的数据重新选中
     */
    async getListAssignRole (row, type = false) {
      let param = {
        corpUserId: row.corpUserId,
        needFilter: 1,
        itemPage: 1,
        pageSize: 50
      };
      let res = await ApiCorpMethods.RoleController.listAssignRole(param);
      if (!res.success) return showRes(res);
      this.distributeRoles = res.data;

      this.$nextTick(() => {
        this.distributeRoles.forEach((role, index) => {
          //初始化roleJson数据
          this.distributeRoleJson.push({
            corpRoleId: role.corpRoleId,
            corpGroupId: role.corpGroupId,
            operType: role.assigned == 1 ? 1 : 0
          });
          if (type && this.selectRows.length > 0) {
            this.selectRows.forEach(row => {
              role.corpRoleId == row.corpRoleId &&
                this.$refs.roleSelection.toggleRowSelection(
                  this.distributeRoles[index],
                  true
                );
            });
          } else if (role.assigned == 1) {
            //默认选中已分配的角色
            this.$refs.roleSelection.toggleRowSelection(
              this.distributeRoles[index],
              true
            );
          }
        });
      });
    },
    async getListAssignSeal (row) {
      let param = {
        corpUserId: row.corpUserId,
        itemPage: 1,
        pageSize: 50
      };
      let res = await ApiCorpMethods.RoleController.listAssignSeal(param);
      if (!res.success) return showRes(res);
      this.distributeSeals = res.data;
      this.$nextTick(() => {
        this.distributeSeals.forEach(seal => {
          this.distributeSealJson.push({
            corpSealId: seal.corpSealId,
            operType: seal.assigned == 1 ? 1 : 0
          });
        });
      });
    },
    /** 判断是否可操作 */
    haveFlag (row) {
      const _this = this;
      const nodeAuth = _this.departmentArray.filter(item => item.corpGroupId === row.corpGroupId)
      return !(nodeAuth && nodeAuth[0] && nodeAuth[0].editFlag === 1)
    },
    /** 删除待接受状态数据 */
    handleDel (row) {
      const _this = this;
      const nodeAuth = _this.departmentArray.filter(item => item.corpGroupId === row.corpGroupId)
      const assignBool = _this.assignRoleVisibleBtn &&
        nodeAuth && nodeAuth[0] && nodeAuth[0].editFlag === 1;
      if (!assignBool) return _this.$message.warning(_this.dataAuthText)
      const bool = _this.permsEven()
      if (!bool) return
      _this.$confirm(
        '是否确定删除？',
        "系统提示",
        {
          confirmButtonText: "继续",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          type: ""
        }
      )
        .then(() => {
          ApiCorpMethods.MemberController.delCorpUser({ corpUserId: row.corpUserId }).then(res => {
            if (!res.success) return _this.$message.error(res.description)
            _this.$message.success(res.description)
            _this.filterSearch()
            _this.initTreeGroup();
          })
        })
        .catch(() => {
          _this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // assign role event
    handleClickAssign (row) {
      const nodeAuth = this.departmentArray.filter(item => item.corpGroupId === row.corpGroupId)
      const assignBool = this.assignRoleVisibleBtn &&
        nodeAuth && nodeAuth[0] && nodeAuth[0].editFlag === 1;
      if (!assignBool) return this.$message.warning(this.dataAuthText)
      const bool = this.permsEven()
      if (!bool) return
      this.distributeRoleJson = [];
      this.distributeSealJson = [];
      this.distibuteInfo = row;
      this.getListAssignRole(row);
      this.getListAssignSeal(row);
      this.showDistribute = true;
    },
    selectedChange (rows, row) {
      this.selectRows = rows;
    },
    //角色分配-选择角色时触发
    distributeRoleSelect (val) {
      for (
        let i = 0, jsonLength = this.distributeRoleJson.length;
        i < jsonLength;
        i++
      ) {
        let matched = false;

        //循环判断是否选中
        for (let j = 0, length = val.length; j < length; j++) {
          if (this.distributeRoleJson[i].corpRoleId === val[j].corpRoleId) {
            this.distributeRoleJson[i].operType = 1;
            matched = true;
            break;
          }
        }

        //没有匹配，则设置为不选中
        if (!matched) {
          this.distributeRoleJson[i].operType = 0;
        }
      }
    },
    chooseAuth (row, index) {
      this.getAuthRange(row);
      this.showChooseAuth = true;
    },
    doChooseAuth () {
      if (this.chooseRange) {
        this.currentRoleRow.groupName = this.chooseRange.groupName;
        this.currentRoleRow.corpGroupId = this.chooseRange.corpGroupId;
        this.$refs.roleSelection.toggleRowSelection(this.currentRoleRow);
        this.$nextTick(() => {
          this.$refs.roleSelection.toggleRowSelection(this.currentRoleRow);
          //根据角色id设置对应的RoleJson中的corpGroupId
          this.distributeRoleJson.forEach(role => {
            if (role.corpRoleId == this.currentRoleRow.corpRoleId) {
              role.corpGroupId = this.currentRoleRow.corpGroupId;
            }
          });
        });
      }
      this.showChooseAuth = false;
    },
    async doDistribute () {
      let param = {
        rolesJson: JSON.stringify(this.distributeRoleJson),
        sealsJson: "",
        corpUserId: this.distibuteInfo.corpUserId
      };
      let res = await ApiCorpMethods.RoleController.assignRole(param);
      if (res.success) {
        if (res.success) res.description = '操作成功，若有修改权限重新登录后生效';
        showRes(res)
      };
      if (res.code === '10802') return this.$message.error(`超出当前账号可管理的部门范围`);
      if (!res.success) return;
      this.queryTool();
      this.showDistribute = false;
      this.selectRows = [];
    },
    async getAuthRange (row) {
      this.currentRoleRow = null;
      this.currentRoleRow = row; //地址赋值，便于修改row
      let res = await ApiCorpMethods.OrganizationController.treeGroup({
        permId: 9
      });
      if (!res.success) return showRes(res);
      this.treeGroup = this.convertFormateTree(res.data);
      this.$nextTick(() => {
        if (this.$refs.treeRef)
          this.$refs.treeRef.setCurrentKey(row.corpGroupId, true);
      });
    },
    // 获取角色下拉数据
    getRoles () {
      ApiCorpMethods.RoleController.roles()
        .then(res => {
          if (res.code === "0") {
            let v = [];
            v.push({ value: "", label: "全部权限" });
            res.data.forEach(element => {
              v.push({ value: element.corpRoleId, label: element.roleName });
            });
            this.$nextTick(() => {
              this.roles = v;
            });
          } else {
            this.$message.error(res.description);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 转换成tree需要的数据格式
    convertFormateTree (data) {
      data.forEach((element, i) => {
        this.departmentArray.push(element);
        element.label = element.groupName + "(" + element.totalNum + "人)";
        if (i === 0) element.disabled = true;
        if (element.childCorpGroups) {
          this.recursionChildren(element.childCorpGroups);
        }
      });
      return data;
    },
    //点击每一个权限范围子节点时触发
    checkGroup (groupObj, node, nodeComp) {
      this.chooseRange = groupObj;
      this.$refs.treeRef.setCurrentKey(groupObj.corpGroupId);
    },
    recursionChildren (childCorpGroups) {
      childCorpGroups.forEach(element => {
        this.departmentArray.push(element);
        element.label = element.groupName + "(" + element.totalNum + "人)";
        this.treeGroupKeys.push(element.corpGroupId);
        if (element.childCorpGroups) {
          this.recursionChildren(element.childCorpGroups);
        }
      });
    },
    clearSelection (refName) {
      if (this.$refs[refName]) {
        this.$refs[refName].clearSelection();
      }
    },
    // init org staructure data
    // 初始化组织机构数据
    // refresh 用于子组件更新数据
    initTreeGroup (refresh = true) {
      let params = {
        permId: 7,
        loadGroupMan: 1
      };
      // params.permId = 3;

      // ApiCorpMethods.OrganizationController.treeGroup(params)
      ApiCorpMethods.OrganizationController.topGroup(params)
        .then(res => {
          if (res.code === "0") {
            this.treeGroup = this.convertFormateTree(res.data);
            this.topGroup = this.convertFormateTree(res.data);
            this.treeGroupCopy = JSON.parse(JSON.stringify(this.treeGroup));
            if (refresh) {
              this.selectTreeNode = this.treeGroupCopy[0]; // 赋初值
            }
          } else {
            this.$message.error(res.description);
          }
        })
        .catch(err => {
          console.log(err);
          this.$message.error(err.description);
        });
    },
    // tree node click event
    // 点击节点触发事件
    handleNodeClick (data, node) {
      this.selectTreeNode = data;
      this.filterModel.itemPage = 1;
      this.filterModel.corpGroupId = data.corpGroupId;
      this.queryTool();
      // 不是点击第一个，就移除第一个的选中状态
      this.$nextTick(() => {
        if (data.corpGroupId !== this.treeGroup[0].corpGroupId) {
          if (this.$refs.memberTree && this.$refs.memberTree.$el) {
            let firstTreeItem = this.$refs.memberTree.$el.querySelector("div");
            firstTreeItem && firstTreeItem.classList.remove("is-current");
          }
        }
      });
    },
    handleNodeClickMove (data) {
      if (data.disabled) return this.$message.error("请选择部门进行调整");
      if (data.editFlag === 0) return this.$message.warning(this.dataAuthText)
      this.moveDeptSelect = data;
    },
    // 重置
    rest () {
      this.filterModel = {
        targetId: "", // 手机/邮箱 ... 关键字
        useStatus: "", // -1未激活 0正常 1停用
        inviteStatus: "", // 邀请状态 -1 未绑定 0 已邀请 1已邀请
        corpRoleId: "", // 角色id
        corpGroupId: this.topGroup[0].corpGroupId, // 部门id (最外层部门id)
        useType: "", // 用户类型 0个人1企业
        itemPage: 1,
        pageSize: 10,
        pageTotal: 0
      };
      // this.selectTreeNode = this.treeGroupCopy[0];
      this.initTreeGroup()
      this.filterSearch();
    },
    // 搜索按钮
    filterSearch (all) {
      this.filterModel.itemPage = 1;
      this.queryTool(all);
    },
    // move org
    // 调整组织(移动组织)
    moveOrg (row) {
      const nodeAuth = this.departmentArray.filter(item => item.corpGroupId === row.corpGroupId)
      const editBool =
        this.assignRoleVisibleBtn &&
        nodeAuth && nodeAuth[0] && nodeAuth[0].editFlag === 1, _this = this;
      if (!editBool) return _this.$message.warning(_this.dataAuthText)
      const bool = _this.permsEven();
      if (!bool) return
      _this.selectUserObj = row;
      _this.visibleMoveOrg = true;
      _this.$nextTick(() => {
        this.$refs.referenceMoveTree.filter()
        // _this.getAuthRange(row)
      })
    },
    moveOrgSubmit () {
      if (this.moveDeptSelect) {
        console.info(this.moveDeptSelect);
        let params = {};
        params.corpUserIds = this.selectUserObj.corpUserId + "";
        params.corpGroupId = this.moveDeptSelect.corpGroupId;
        ApiCorpMethods.MemberController.batchMoveGroup(params)
          .then(res => {
            if (res.code === "0") {
              this.visibleMoveOrg = false;
              this.$message.success("调整组织成功");
              this.queryTool();
              this.initTreeGroup();
            } else {
              this.$message.error(res.description);
            }
          })
          .catch(error => {
            this.$message.error(err.description);
          });
      } else {
        this.$message.error("请选择要转移的部门");
      }
    },
    // 成员类型change事件
    handleChangeMemberType1 (val) {
      this.$nextTick(() => {
        this.$refs["dialogModelBindMember"].validate(valid => {
        });
      });
    },
    // 成员类型change事件
    handleChangeMemberType2 (val) {
      this.$nextTick(() => {
        this.$refs["dialogModelReBindMember"].validate(valid => {
        });
      });
    },
    // add a member
    // 添加成员
    addMember () {
      if (isInDingTalk) {
        // 邀请钉钉成员
        this.chooseMenber();
      } else {
        const bool = this.permsEven()
        if (!bool) return
        this.visibleAddMember = true;
      }
    },
    // 邀请（鉴权 + 选人）
    chooseMenber () {
      const corpId = sessionStorage.getItem("corpId"),
        _this = this;
      const dingtokenInfo = JSON.parse(sessionStorage.getItem("dingloginInfo")),
        dingInfo = {
          corpId: dingtokenInfo.dingTalkCorpId,
          dingTalkUserId: dingtokenInfo.dingTalkUserId
        };
      dingtalkApi.groupUserList(dingInfo).then(res => {
        if (!res.success) return this.$message.error(res.description);
        const userList = res.data;
        let _users = [];
        userList.forEach(item => {
          _users.push(item.dingTalkUserId);
        });
        _this.DINGSDK && _this.DINGSDK.complexChoose({
          maxUsers: 150,
          pickedUsers: [],
          corpId,
          multiple: true,
          disabledUsers: _users,
          success: res => {
            const { users } = res,
              userIds = [];
            users.forEach(user => {
              userIds.push(user.emplId);
            });
            const param = {
              ...dingInfo,
              receiverList: userIds
            };
            if (userIds.length === 0)
              return _this.$message.error("已接受邀请的人员将不会再进行邀请");
            const userNames=users.map(user=> user.name)
            dingtalkApi.useInvite(param).then(res => {
              if (!res.success) return _this.$message.error(res.description);
              callbackLog({
                module:0,
                desc:`邀请成员：${userNames.toString()}`
                })
              _this.$message.success(
                res.description || "消息发送成功，待受邀成员确认"
              );
            });
          },
        }).catch((err) => { 'catch_err:', err });
      });
    },
    addMemberConfirmSuccess () {
      const phone = "18280224931";
      this.$confirm(
        `
			<h5>添加成功</h5>
			<p style="color:#666666">系统已发送邀请短信到<strong>${phone}</strong>的手机上,需成员接受邀请</p>
		`,
        "",
        {
          confirmButtonText: "确定",
          showClose: false,
          dangerouslyUseHTMLString: true,
          type: "success",
          showCancelButton: false
        }
      );
    },
    addMemberConfirmWarning () {
      this.$confirm(
        `
			<h5>此账号已加入组织</h5>
			<p style="color:#666666">请选择其它账号</p>
		`,
        "",
        {
          confirmButtonText: "确定",
          showClose: false,
          dangerouslyUseHTMLString: true,
          type: "warning",
          showCancelButton: false
        }
      );
    },
    // 获取成员数据
    queryTool (all) {
      /**
       * table data desription
       * "useStatus" 0 未绑定 1 正常 2 待接受
       * "corpRoleId": 0 高级管理员 1 普通员工 2 签章使用人 3 合同查看人
       * "type": 0 个人 1 企业
       */
      this.filterModel.permId = 3;
      this.selectMember = undefined;
      // * 20240116;刘总说查询查公司全部成员 (最外层组织corpGroupId)
      if (all) this.filterModel.corpGroupId = this.topGroup[0].corpGroupId
      ApiCorpMethods.MemberController.listCorpUsers(this.filterModel)
        .then(res => {
          if (res.code === "0") {
            res.data.forEach(item => {
              item._roleNames = []
              if (item.roleNames) {
                const param = {
                  corpUserId: item.corpUserId,
                  itemPage: 1,
                  pageSize: 50
                };
                new Promise((resolve, reject) => {
                  const res = ApiCorpMethods.RoleController.listAssignRole(param)
                  resolve(res)
                }).then(res => {
                  const roleRes = res.data
                  roleRes && roleRes.length > 0 && roleRes.forEach(role => {
                    if (role.assigned === 1) item._roleNames.push(`${role.roleName} / ${role.groupName}`)
                  })
                }).catch((err) => {
                  console.log('catch_err:', err);
                });
              }
            });
            this.tableList = res.data;
            this.filterModel.pageTotal = res.total;
            if (all) {
              this.filterModel.targetId = ''
              this.initTreeGroup()
            }
          } else {
            this.$message.error(res.description);
          }
        })
        .catch(error => {
          console.info(error);
          this.$message.error(error.description);
        });
    },
    // init table data
    // 初始化成员table列表
    initTableData () {
      this.queryTool();
    },
    // selection change event
    // 当选择项发生变化时会触发该事件
    handleSelectionChange (val) {
      console.info(val);
      this.selectMember = val;
    },
    // handle click bind evnet
    //contractSendFn合同数据发送
    contractSendFn () {
      if (!this.contractSendActive) {
        return this.$message.error("请选择人员");
      }
      ApiCorpMethods.ContractController.contractSend({
        sourceCorpUserId: this.dialogModelBindMember.corpUserId,
        targetCorpUserId: this.contractSendActive
      }).then(res => {
        if (res.success) {
          this.$message.success("操作成功");
          this.contractSendVisible = false;
          this.initTableData();
          this.initTreeGroup();
        } else {
          this.$message.error(res.description);
        }
      });
    },
    contractVisibleFn (row) {
      const nodeAuth = this.departmentArray.filter(item => item.corpGroupId === row.corpGroupId)
      if (nodeAuth && nodeAuth[0] && nodeAuth[0].editFlag !== 1) return this.$message.warning(this.dataAuthText)
      const bool = this.permsEven()
      if (!bool) return
      this.dialogModelBindMember.corpUserId = row.corpUserId;
      this.contractSendVisible = true;
      this.filterModelNew.targetId = '';
      this.contractSendActive = "";
      if (this.filterModelNew.itemPage !== 1) {
        this.filterModelNew.pageSize = 10;
        this.filterModelNew.itemPage = 1;
      }
      this.contractSendUserListFn();
    },
    contractSendUserListFn () {
      this.filterModelNew.permId = this.filterModel.permId;
      ApiCorpMethods.MemberController.listCorpUsers(this.filterModelNew).then(
        res => {
          // console.log("contractSendUserList", this.contractSendUserList);
          this.contractSendUserList = res.data;
          this.filterModelNew.pageTotal = res.total;
        }
      );
    },
    // 邀请
    handleClickBind (row) {
      // 没有部门节点 editFlag 类型  return
      const nodeAuth = this.departmentArray.filter(item => item.corpGroupId === row.corpGroupId)
      if (nodeAuth && nodeAuth[0] && nodeAuth[0].editFlag !== 1) return this.$message.warning(this.dataAuthText)
      const bool = this.permsEven()
      if (!bool) return
      this.dialogModelBindMember.corpUserId = row.corpUserId;
      if (this.$refs["dialogModelBindMember"]) {
        this.$refs["dialogModelBindMember"].resetFields();
      }
      this.dialogModelBindMember.type = 0;
      this.visibleBindMember = true;
    },
    bindMemberSubmit () {
      this.$refs["dialogModelBindMember"].validate(valid => {
        if (valid) {
          let params = {};
          params.userType = this.dialogModelBindMember.type; // 0个人1企业
          let targetId =
            this.dialogModelBindMember.type === 0
              ? this.dialogModelBindMember.phone
              : this.dialogModelBindMember.email;
          params.targetId = targetId; // 手机或邮箱
          let userName =
            this.dialogModelBindMember.type === 0
              ? this.dialogModelBindMember.name
              : this.dialogModelBindMember.enterpriseName;
          params.userName = userName; // 用户名称(名称大于1个字小于50个字)
          (params.corpUserId = this.dialogModelBindMember.corpUserId),
            ApiCorpMethods.MemberController.bindCorpUser(params)
              .then(res => {
                if (res.code === "0") {
                  this.visibleBindMember = false;
                  this.queryTool();
                } else {
                  this.$message.error(res.description);
                }
              })
              .catch(error => {
                this.$message.error(err.description);
              });
        }
      });
    },
    // handle click unbind evnet
    // 移除
    handleClickUnbind (row) {
      const nodeAuth = this.departmentArray.filter(item => item.corpGroupId === row.corpGroupId)
      if (nodeAuth && nodeAuth[0] && nodeAuth[0].editFlag !== 1) return this.$message.warning(this.dataAuthText)
      const bool = this.permsEven()
      if (!bool) return
      this.$confirm(
        `
			<h5>是否移除</h5>
			<p style="color:#F56C6C">
			移除后当前用户将无法以当前企业身份发起合同或管理当前企业，
				<span style="color:#666666">是否继续？</span>
			</p>
		`,
        "",
        {
          confirmButtonText: "继续",
          cancelButtonText: "取消",
          showClose: false,
          dangerouslyUseHTMLString: true,
          type: "warning"
        }
      )
        .then(() => {
          let params = {};
          params.corpUserId = row.corpUserId;
          ApiCorpMethods.MemberController.unbindCorpUser(params)
            .then(res => {
              if (res.code === "0") {
                this.queryTool();
                this.initTreeGroup();
              } else {
                this.$message.error(res.description);
              }
            })
            .catch(error => {
              this.$message.error(err.description);
            });
        })
        .catch(() => {
        });
    },
    // handle click reinvite evnet
    // 重新邀请
    handleClickReinvite (row) {
      const nodeAuth = this.departmentArray.filter(item => item.corpGroupId === row.corpGroupId)
      if (nodeAuth && nodeAuth[0] && nodeAuth[0].editFlag !== 1) return this.$message.warning(this.dataAuthText)
      const bool = this.permsEven()
      if (!bool) return
      this.$confirm(
        `
			<h5>是否重新邀请</h5>
			<p style="color:#F56C6C">
				重新发起邀请,之前的邀请将会失效,
				<span style="color:#666666">您还要继续吗?</span>
			</p>
		`,
        "",
        {
          confirmButtonText: "继续",
          cancelButtonText: "取消",
          showClose: false,
          dangerouslyUseHTMLString: true,
          type: "warning"
        }
      )
        .then(() => {
          this.dialogModelReBindMember.corpUserId = row.corpUserId;
          this.dialogModelReBindMember.type = row.useType;
          this.dialogModelReBindMember.phone = "";
          this.dialogModelReBindMember.email = "";
          this.dialogModelReBindMember.name = "";
          this.dialogModelReBindMember.enterpriseName = "";
          if (row.useType === 0) {
            this.dialogModelReBindMember.phone = row.targetId;
            this.dialogModelReBindMember.name = row.userName;
          } else {
            this.dialogModelReBindMember.email = row.targetId;
            this.dialogModelReBindMember.enterpriseName = row.userName;
          }
          this.visibleReBindMember = true;
          if (this.$refs["dialogModelReBindMember"]) {
            this.$refs["dialogModelReBindMember"].clearValidate();
          }
        })
        .catch(() => {
        });
    },
    rebindMemberSubmit () {
      this.$refs["dialogModelReBindMember"].validate(valid => {
        if (valid) {
          let params = {};
          params.userType = this.dialogModelReBindMember.type; // 0个人1企业
          let targetId =
            this.dialogModelReBindMember.type === 0
              ? this.dialogModelReBindMember.phone
              : this.dialogModelReBindMember.email;
          params.targetId = targetId; // 手机或邮箱
          let userName =
            this.dialogModelReBindMember.type === 0
              ? this.dialogModelReBindMember.name
              : this.dialogModelReBindMember.enterpriseName;
          params.userName = userName; // 用户名称(名称大于1个字小于50个字)
          (params.corpUserId = this.dialogModelReBindMember.corpUserId),
            ApiCorpMethods.MemberController.bindCorpUser(params)
              .then(res => {
                if (res.code === "0") {
                  this.visibleReBindMember = false;
                  this.queryTool();
                } else {
                  this.$message.error(res.description);
                }
              })
              .catch(error => {
                this.$message.error(err.description);
              });
        }
      });
    },
    // pagination eventperm
    // 分页事件
    handleSizeChange (val) {
      this.filterModel.itemPage = 1;
      this.filterModel.pageSize = val;
      this.queryTool();
    },
    handleCurrentChange (val) {
      this.filterModel.itemPage = val;
      this.queryTool();
    },
    handleSizeChangeNew (val) {
      this.filterModelNew.itemPage = 1;
      this.filterModelNew.pageSize = val;
      this.contractSendUserListFn();
    },
    handleCurrentChangeNew (val) {
      this.filterModelNew.itemPage = val;
      this.contractSendUserListFn();
    },
    // **************角色权限相关 start*************
    modelTpl () {
      return {
        roleName: "",
        remark: "",
        perms: []
      };
    },
    // 成功修改或者新增角色权限
    susChange () {
      this.getListAssignRole(this.distibuteInfo, true);
    },
    async editRole (row) {
      // this.clearModel()
      //获取角色详情
      this.diaTitle = "查看权限组";
      let res = await ApiCorpMethods.RoleController.detail({
        corpRoleId: row.corpRoleId
      });
      if (res.success) {
        this.rowInfo = res.data;
        this.dialogVisi = !this.dialogVisi;
        this.roleModel = {
          ...this.modelTpl(),
          ...res.data
        };
        this.showRole = true;
      }
    },
    delRole (row) {
      this.$confirm(
        '<p style="font-size: 16px;"><i class="el-icon-warning" style="color: #e6a23c;font-size: 20px; width: 30px;"></i>是否删除权限组</p><p style="font-size: 14px; color: #a6a69e;padding-left: 30px;"><span style="color: red;">删除后将不会恢复</span>，你还要继续吗？</p>',
        "",
        {
          confirmButtonText: "继续",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          type: ""
        }
      )
        .then(async () => {
          let delRes = await ApiCorpMethods.RoleController.delRole({
            corpRoleId: row.corpRoleId
          });
          showRes(delRes);
          if (delRes.success) this.getListAssignRole(this.distibuteInfo);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    }
    // **************角色权限相关 end*************
  },
  computed: {
    ...mapGetters(["currentAuthUser", "allAuthUser"]),
    perms () {
      return this.currentAuthUser.perms ? this.currentAuthUser.perms : [];
    },
    saasDeft () {
      const outline = this.treeGroup[0]
      return outline && outline.childCorpGroups ? outline.childCorpGroups : []
    },
    isAdmin () {
      // 老刘说窗口难看，暂时不展示
      if (isInDingTalk) {
        const { sys } = JSON.parse(sessionStorage.getItem("dingloginInfo"))
        return isInDingTalk && sys
      } else {
        return false
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import url('../../../assets/style/cssVariable.less');
.apply-sty {
  position: absolute;
  top: -8px;
  right: -8px;
  font-weight: normal;
  display: inline-block;
  text-align: center;
  line-height: 18px;
  color: #fff;
  font-size: 14px;
  background-color: #ec1c1c;
  width: 18px;
  height: 18px;
  border-radius: 50%;
}
.tr-overflow {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.el-button--primary.is-plain:hover,
.el-button--primary.is-plain:active,
.el-button--primary.is-plain:focus {
  color: #fff;
  background-color: #ec1c1c;
  border-color: #ec1c1c;
}

.el-form-item {
  /*margin-bottom: 15px;*/
  margin-bottom: 5px;
}

.contract_li {
  padding: 10px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;

  &.active {
    background-color: #f0f0f0;
    color: #ec1c1c;
  }
}

/deep/ .tree-style {
  .el-tree-node__label {
    white-space: nowrap;
    overflow-x: hidden;
    text-overflow: ellipsis;
  }
}

.tree-title {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .tree-img {
    width: 15px;
    height: 15px;
    vertical-align: middle;
    margin-right: 5px;
    background: url("/images/console/set.png") no-repeat;
    background-size: cover;

    &:hover {
      background: url("/images/console/setHover.png") no-repeat;
      background-size: cover;
    }
  }
}

/deep/ .member-tree {
  margin-top: 15px;

  .is-checked {
    & > .el-tree-node__content {
      background-color: @ebq-left-selected;
    }
  }

  & > .el-tree-node {
    .is-current > .el-tree-node__content {
      color: #ec1c1c;

      &:before {
        background-image: url("/static/images/console/member-leafHover.png");
      }
    }

    & > .el-tree-node__content {
      &:before {
        background-image: url("/static/images/console/member-root.png");
      }
    }
  }

  .el-tree-node__content {
    position: relative;
    margin-bottom: 5px;
    padding-left: 20px;

    &:before {
      position: absolute;
      content: "";
      display: inline-block;
      width: 15px;
      height: 15px;
      top: 50%;
      margin-left: 16px;
      margin-top: -7px;
      background-image: url("/static/images/console/member-leaf.png");
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
    }

    .el-icon-caret-right {
      position: relative;
      padding: 20px;
      margin-left: -20px;

      &.is-leaf {
        visibility: hidden;
      }

      &.expanded:before {
        height: 0;
      }
    }
  }

  .wrap {
    width: calc(100% - 40px);
    font-size: 0;
    margin-left: 5px;
    display: flex;
    align-items: center;
    .option-sty {
      display: flex;
      align-items: center;
      > i {
        font-size: 15px;
        font-weight: bolder;
        color: #ec1c1c;
        margin: 0 5px;
      }
    }

    .name {
      max-width: calc(100% - 40px);
      float: left;
      white-space: nowrap;
      overflow-x: hidden;
      text-overflow: ellipsis;
      vertical-align: middle;
      font-size: 14px;
    }

    .count {
      float: left;
      font-size: 14px;
      margin-right: 10px;
    }
  }
}

.org-tree {
  /*width: 25vw;*/
  width: 400px;
  margin-right: 10px;
  // border-radius: 2px;
  // position: absolute;
  background: #ffffff;
  // width: 397px;
  // top: 0;
  // left: 0;
  // bottom: 0;
  // overflow: auto;
  // padding-bottom: 10px;
  // scrollbar-width: none;
  .arch-model-sty{
    padding-left: 15px;
    margin-top: 10px;
    display: flex;
    align-items: center;
    font-size: 15px;
    .chang-box-sty{
      display: inline-block;
      color: #ec1c1c;
      margin: 0 15px;
      cursor: pointer;
      .change-icon-sty{
        transform: rotate(90deg);
        font-weight: bolder;
        font-size: 25px;
      }
    }
  }
}
.right-box {
  flex: 1;
  background: #ffffff;
  // min-height: calc(100vh - 270px);
  // margin-left: 415px;
  // border-radius: 2px;
  .flex-sty {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-right: 20px;
  }
}

.m-box {
  display: flex;
  // position: relative;
  // background-color: #f3f6f1;
}

.my-title {
  font-size: 14px;
  font-family: Source Han Sans SC;
  font-weight: 400;
  color: rgba(41, 2, 2, 0.65);
  margin-bottom: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  img {
    width: 20px;
    height: auto;
    margin-right: 5px;
    vertical-align: middle;
  }

  a {
    cursor: pointer;
    font-family: Source Han Sans SC;
    font-weight: bold;
    color: rgba(41, 2, 2, 1);

    &:hover {
      color: #ec1c1c;
    }
  }
}

.color-success {
  color: #290202;
  font-weight: bold;
  cursor: pointer;
}

.color-success:hover {
  color: #ec1c1c;
}
.dis-sty {
  color: #ccc;
  cursor: not-allowed;
}
.dis-sty :hover {
  color: #ccc !important;
}

/*删除线*/
.delline {
  position: relative;

  span {
    position: absolute;
    height: 1px;
    background: #fe8624;
    display: block;
    left: -5%;
    right: -5%;
    top: 50%;
  }
}
</style>
<style scoped>
.dot-gray {
  color: #b7b7b7;
}

.dot-green {
  color: #46cccb;
}

.dot-red {
  color: #ec1c1c;
}

.dot-orange {
  color: #fe8624;
}

.custom-transform-rotateZ-180 {
  transition: -webkit-transform 0.3s;
  transition: transform 0.3s;
  transition: transform 0.3s, -webkit-transform 0.3s;
  transition: transform 0.3s, -webkit-transform 0.3s;
  -webkit-transform: rotateZ(180deg);
  transform: rotateZ(180deg);
}

.custom-transform-rotateZ-0 {
  transition: -webkit-transform 0.3s;
  transition: transform 0.3s;
  transition: transform 0.3s, -webkit-transform 0.3s;
  transition: transform 0.3s, -webkit-transform 0.3s;
  -webkit-transform: rotateZ(0deg);
  transform: rotateZ(0deg);
}

.tree-style >>> .el-tree-node.is-current > .el-tree-node__content {
  background-color: #eeeeee;
}

.ellipses-1 {
  display: block;
  float: left;
  max-width: calc(100% - 62px);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.ellipses-1-full {
  display: block;
  float: left;
  max-width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.ellipses-2 {
  display: block;
  float: left;
  width: 60px;
  text-align: center;
}

.warn-img {
  color: #e6a23c;
  font-size: 18px;
}

.warn-img::before {
  content: "\E7A3";
}
</style>



// WEBPACK FOOTER //
// components/console/memberManage/memberCom.vue